import defaultAvatar from '@/assets/images/profile.png'
import { login, logout } from '@/api/auth/login'
import { getUserInfo } from '@/api/auth/user'
import { getToken, removeToken, setToken } from '@/utils/auth'
import { getPictureShowUrl } from '@/utils/common'

const state = {
  token: getToken(),
  username: '',
  userType: 0,
  avatar: '',
  nickName: '',
  roleCodes: [],
  permissionCodes: []
}

const getters = {
  token: (state) => state.token,
  username: (state) => state.username,
  userType: (state) => state.userType,
  avatar: (state) => state.avatar,
  nickName: (state) => state.nickName,
  roleCodes: (state) => state.roleCodes,
  permissionCodes: (state) => state.permissionCodes
}

const mutations = {
  setToken: (state, token) => {
    state.token = token
  },
  setUsername: (state, username) => {
    state.username = username
  },
  setUserType: (state, userType) => {
    state.userType = userType
  },
  setAvatar: (state, avatar) => {
    state.avatar =
      avatar === null || avatar === ''
        ? defaultAvatar
        : getPictureShowUrl(avatar)
  },
  setNickName: (state, nickName) => {
    state.nickName = nickName
  },
  setRoleCodes: (state, roleCodes) => {
    state.roleCodes = roleCodes
  },
  setPermissionCodes: (state, permissionCodes) => {
    if (permissionCodes) {
      state.permissionCodes = permissionCodes
    } else {
      state.permissionCodes = []
    }
  }
}

const actions = {
  // 登录
  login({ commit }, userInfo) {
    const { username, password, uuid, code } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username,
        password,
        uuid,
        code
      })
        .then((response) => {
          const {
            data: { token }
          } = response
          setToken(token)
          commit('setToken', token)
          resolve()
        })
        .catch((error) => {
          console.log('error = ', error)
          reject(error)
        })
    })
  },

  // 获取用户信息
  async getUserInfo({ commit }) {
    const {
      data: { username, avatar, roleCodes, permissionCodes, userType, nickName }
    } = await getUserInfo()
    commit('setUsername', username)
    commit('setUserType', userType)
    commit('setRoleCodes', roleCodes)
    commit('setPermissionCodes', permissionCodes)
    commit('setAvatar', avatar)
    commit('setNickName', nickName)
  },

  // 退出登录
  async logout({ commit }) {
    try {
      await logout()
    } catch (error) {
      console.log(error)
    }

    commit('setToken', '')
    commit('setRoleCodes', [])
    removeToken()
  },

  // 设置头像
  setAvatar({ commit }, data) {
    commit('setAvatar', data)
  },
  // 设置 token
  setToken({ commit }, data) {
    commit('setToken', data)
  }
}

export default { namespaced: true, state, getters, mutations, actions }
